<template>
  <footer class="page-footer">
    <div class="container">
      <div class="row">
        <div class="col-xs-6">
          <h6 class="_margin-bottom-0">{{ appSettings.supplierName }} customer services email</h6> <a
            :href="`mailto:${appSettings.supplierEmail}`">{{ appSettings.supplierEmail }}</a>
        </div>
        <div class="col-xs-6 text-right">
          <a :href="appSettings.supplierTermsAndConditions" target="_blank">Terms & Conditions</a>
          <a class="padding-left" :href="appSettings.supplierPrivacyPolicy" target="_blank">Privacy Policy</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'PageFooter',
  computed: {
    ...mapState({
      appSettings: ({ app_settings }) => app_settings
    })
  }
};
</script>

<style lang="scss">
.page-footer {
  background: #242828;
  padding: 15px;
  margin-top: 30px;

  h6 {
    color: #fff;
  }

  a {
    font-size: 14px;
    color: #a6a6a6;
    font-weight: bold;

    &:hover,
    &:focus {
      color: $brand-colour-primary;
    }

    @media (max-width: 767px) {
      display: block;
      margin-bottom: 5px;
    }
  }

  .padding-left {
    padding-left: 15px;
  }
}
</style>
